<template>
  <div class="manage-purchases">
    <b-table-simple
      hover small caption-top responsive>
      <b-thead head-variant="light">
        <b-tr>
          <b-th>Date</b-th>
          <b-th>Ref No.</b-th>
          <b-th>Type</b-th>
          <b-th>Listing</b-th>
          <b-th>User</b-th>
          <b-th class="text-right">Amount</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="transaction in transactions"
          :key="transaction.id">
          <b-td>
            {{ transaction.createdAt | date }}
          </b-td>
          <b-td>
            {{ transaction.reference }}
          </b-td>
          <b-td>
            {{ transaction.type }}
          </b-td>
          <b-td>
            <router-link
              class="font-weight-bold"
              target="_blank"
              :title="transaction.listing.title"
              :to="`/listing/${transaction.listing.id}`">
              <small
                class="font-weight-bold">
                {{ transaction.listing.title | truncate }}
              </small>
            </router-link>
          </b-td>
          <b-td>{{ transaction.user.firstName }} {{ transaction.user.lastName }}</b-td>
          <b-td
            class="text-right">{{ transaction.amount * -1 | currency }}</b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <b-tr>
          <b-td
            colspan="7"
            class="text-right">
            <b>{{ total * -1 | currency }}</b>
          </b-td>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>

<script>
import moment from 'moment'
import currency from '@/filters/currency.filter'

const date = val => moment.unix(val / 1000).format('MM/DD/YYYY')

const truncate = (val) => {
  const maxLength = 17
  return val.length > maxLength
    ? `${val.substring(0, maxLength)}...`
    : val
}

export default {
  name: 'ManagePurchases',
  filters: {
    currency,
    date,
    truncate,
  },
  data() {
    return {
      transactions: [],
      total: 0,
    }
  },
  methods: {
    async fetchTransactions() {
      const { data: { transactions, total } } = await this.$http.get('/admin/transactions')
      this.transactions = transactions
      this.total = total
    },
  },
  created() {
    this.fetchTransactions()
  },
}
</script>
